/**
 * @author Pawan Sadvale
 * @email Pawan.Sadvale@ul.com
 * @create date 2019-07-26 09:21:03
 * @modify date 2019-07-26 09:21:03
 * @desc api services page
 */
import axios from 'axios';

/**
 * reg/guide/id get api
 * to get regs & guidance bases on countryid */
export async function getRegsAndGuidance(country) {
  let tableData;
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/reg/guide/${country}`)
    .then((response) => {
      tableData = response.data;
    })
    .catch((err) => {
      console.log('getRegistrationDetailsById java api error', err); // eslint-disable-line no-console
    });
  return tableData;
}

/**
 *  genratetoken post api
 *  for get the token to upload the file to the azure blob storage */
export async function getSasToken(formData) {
  let token;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/sastoken/genratetoken`, formData)
    .then((response) => {
      token = response.data;
    })
    .catch((err) => {
      console.log('genratetoken java api error', err); // eslint-disable-line no-console
    });
  return token;
}

/**
 * /reg/guide/add post api
 *  is to add new document to regs and guidance */
export async function addDocument(formData) {
  let result;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/reg/guide/add`, formData)
    .then((response) => {
      result = response;
    })
    .catch((err) => {
      console.log('/reg/guide/add java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * /reg/guide put api
 * is to edit and update the reg document */
export async function editDocument(formData) {
  let result;
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/reg/guide`, formData)
    .then((response) => {
      if (response && response.data.status_code === 200 && response.data.message === 'success') {
        result = true;
      }
    })
    .catch((err) => {
      console.log('/reg/guide put java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * Regs/guide delete api
 * is to delete the regs and guidance record */
export async function deleteRegsAndGuidance(id) {
  let delTableData;
  await axios
    .delete(`${process.env.VUE_APP_JAVA_API_URL}/reg/guide/${id}`)
    .then((response) => {
      delTableData = response.data;
    })
    .catch((err) => {
      console.log('/reg/guide delete java api error', err); // eslint-disable-line no-console
    });
  return delTableData;
}

/**
 * reg/guide/add/countries post api
 * is to add new country to reg and guidance */
export async function addNewRegGuideCountry(data) {
  let addedCountry = false;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/reg/guide/add/countries`, data)
    .then((response) => {
      if (response && response.data.status_code === 200 && response.data.message === 'success') {
        addedCountry = true;
      }
    })
    .catch((err) => {
      console.log('/reg/guide delete java api error', err); // eslint-disable-line no-console
    });
  return addedCountry;
}

export async function getMatchedRecordForGlobalSearch(serviceId) {
  let tableData;
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/reg/guide/global/search/result/match/${serviceId}`)
    .then((response) => {
      tableData = response.data.data;
    })
    .catch((err) => {
      console.log('getRegistrationDetailsById java api error', err); // eslint-disable-line no-console
    });
  return tableData;
}
